import axios from 'axios'

export const MaterialApi = {
    async Table(data){
        const response = await axios.post('/api/material/table',data)
        return response
    },
    async CreateOrUpdate(update,data){
        const response = await axios.post(update ? '/api/material/update' : '/api/material/create' , data)
        return response
    },
    async Delete(data){
        const response = await axios.post(`/api/material/delete/${data}`)
        return response
    },
    async List(){
        const response = await axios.get('api/material/list')
        return response
    },
    async ListByRegion(startRegionId){
        const response = await axios.get(`api/material/listbyregion/${startRegionId}`)
        return response
    },
    async CreateOrUpdateTransferRegion(data){
        const response = await axios.post('/api/material/createorupdate/transferregions',data)
        return response
    },
    async GetTransferRegions(id){
        const response = await axios.get(`/api/material/get/transferregions/${id}`)
        return response
    },
    
}